import React, { useEffect, useState } from "react";

import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    dialogActions: {
        justifyContent: 'center'
    },
    formWrapper: {
        minWidth: 400,
        maxWidth: 650,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    inputField: {
        '& .MuiTextField-root': {
            width: '40ch',
        },
    },
}));

const LeadsImportSMS = ({ leads, open, handleClose, setSnackbarMessage, setOpenSnackbar }) => {
    if (!open || !leads || !leads.length) {
        return null;
    }
    const classes = useStyles();

    const [phoneNumbers, setPhoneNumbers] = useState([]);

    useEffect(() => {
        getPhoneNumbers();
    }, []);

    const getPhoneNumbers = () => {
        fetch('/admin/sms/phone-numbers', { method: 'GET' })
        .then(response => {
            return response.json();
        })
        .then(result => {
            setPhoneNumbers(result);
        })
        .catch(reason => {
            alert('An error prevented getting phone number senders.');
        })
    };

    const leadIds = leads.map(x => x.id);

    const [loading, setLoading] = useState(false);
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');
    const [messageField, setMessageField] = useState('');

    const handlePhoneNumberChange = (event) => {
        setSelectedPhoneNumber(event.target.value);
    }

    const handleMessageChange = (event) => {
        setMessageField(event.target.value);
    }

    const handleSend = () => {
        if (!messageField || !selectedPhoneNumber) {
            alert('Missing one of the following: phone number, message');
            return;
        }
        setLoading(true);
        const formData = new FormData();
        formData.append('_token', window._token);
        formData.append('phoneNumberId', selectedPhoneNumber);
        formData.append('messageField', messageField);
        formData.append('leads', leadIds);
        let url = '/admin/leads/import/sms';
        fetch(url, {
            method: 'POST',
            body: formData
        })
        .then(response => {
            return response.json();
        })
        .then(result => {
            console.log(result);
            setLoading(false);
            setSnackbarMessage('Successfully sent message');
            setOpenSnackbar(true);
        })
        .catch(reason => {
            setLoading(false);
            alert('An error prevented submitting. Please try again.');
        })
    }

    const leadsPlural = leads.length === 1 ? 'lead' : 'leads';

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth='lg'
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>Send SMS To Leads</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
                <Typography>Send text messages to {leads.length} {leadsPlural}</Typography>
                <div className={classes.formWrapper}>
                    <Box className={classes.inputField}>
                        <Box mt={2} mb={1}>
                            <Typography variant="subtitle2">1. Set Phone Number for Sender</Typography>
                        </Box>
                        <TextField
                            value={selectedPhoneNumber}
                            onChange={handlePhoneNumberChange}
                            select
                            helperText="This is the sender phone number"
                            variant="outlined"
                        >
                            {phoneNumbers && phoneNumbers.length > 0 && (
                                phoneNumbers.map((option, index) => (
                                    <MenuItem value={option.id} key={`phonenumber-${index}`}>{option.friendly_name}</MenuItem>
                                ))
                            )}
                            {!phoneNumbers && <MenuItem>---</MenuItem>}
                        </TextField>
                    </Box>
                    <Box>
                        <Box mt={2} mb={1}>
                            <Typography variant="subtitle2">2. Enter SMS Message</Typography>
                        </Box>
                        <TextField
                            fullWidth
                            value={messageField}
                            onChange={handleMessageChange}
                            placeholder="Enter text message"
                            variant="outlined"
                            multiline
                            rows={8}
                            helperText="To personalize the message with the display name, include {display_name} as a placeholder"
                        />
                    </Box>
                </div>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button disabled={loading} onClick={handleClose} className={classes.dialogButton}>
                    Close
                </Button>
                <Button onClick={handleSend} disabled={loading || !selectedPhoneNumber || !messageField} color="primary" variant="contained" className={classes.dialogButton}>
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default LeadsImportSMS;
